var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4736 66.6751L97.8439 33.0853L98.0154 33.0187C98.0531 33 97.9713 33.0358 98.0103 33.0207C99.2427 32.5419 101.091 33.8147 101.92 35.9493C102.75 38.0839 102.042 40.2499 100.81 40.7287L101.104 40.6363L17.1031 74.449",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0589 51.0844C53.0589 51.0844 51.9871 54.2494 48.8152 52.7332",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7127 61.72C26.7127 61.72 24.8166 66.8265 19.9902 64.5317",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7126 48.195C60.7126 48.195 59.5719 51.3588 56.3983 49.8432",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1685 45.4868C67.1685 45.4868 66.0764 48.7756 62.9045 47.2593",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1836 41.8123C76.1836 41.8123 75.636 45.4113 71.8338 43.5902",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2254 39.3552C82.2254 39.3552 81.4494 43.141 77.6054 41.3481",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0629 37.0871C88.0629 37.0871 87.2079 40.6996 83.3639 38.9067",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6083 38.76C98.8411 38.281 99.5961 37.2637 99.2946 36.4876C98.9931 35.7116 97.7493 35.4708 96.5165 35.9498C95.2837 36.4287 94.5287 37.4461 94.8302 38.2221C95.1317 38.9981 96.3755 39.2389 97.6083 38.76Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5592 44.134C92.5592 44.134 92.1208 54.6371 102.628 50.1512C102.628 50.1512 113.338 47.2036 108.428 32.5336C108.428 32.5336 106.041 25.3749 97.2638 23.1238C97.2638 23.1238 73.4743 16.7601 86.9438 5.18023C86.9438 5.18023 77.8738 11.4087 82.9387 17.0431C82.9387 17.0431 88.7602 22.5934 97.2293 24.0508C97.2293 24.0508 103.145 24.879 106.504 30.0448C106.504 30.0448 114.371 44.7792 102.901 50.8529C91.4304 56.9283 92.5592 44.134 92.5592 44.134Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4755 20.6167C97.4755 20.6167 89.4621 16.2638 92.9996 13.1643C96.5378 10.0665 97.4755 20.6167 97.4755 20.6167Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4043 14.3115C80.4043 14.3115 71.6826 8.16079 76.6006 7.58345C81.5185 7.00612 80.4043 14.3115 80.4043 14.3115Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2142 23.8895C93.2142 23.8895 88.4197 27.8672 87.1126 25.4985C85.8055 23.1297 93.2142 23.8895 93.2142 23.8895Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0557 74.5034C18.2885 74.0244 18.6157 71.906 17.7865 69.7717C16.9573 67.6374 15.2857 66.2955 14.0529 66.7745C12.8201 67.2534 12.4929 69.3719 13.3221 71.5062C14.1513 73.6405 15.8229 74.9824 17.0557 74.5034Z",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5592 44.1339L93.939 43.5819C95.8053 38.489 91.2202 35.6586 91.2202 35.6586L89.7904 36.2881C89.7904 36.2881 94.4327 39.0243 92.5671 44.1189",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6228 57.3356L42.4257 53.1386",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7838 54.9269L37.9716 53.3",
    stroke: "#F8F5E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlute);
export default __webpack_public_path__ + "static/media/flute.8d809b85e63ca3b7852b6f2ffc96ed27.svg";
export { ForwardRef as ReactComponent };